import React from 'react';
import BaseCard from './BaseCard';
import InputTypesEnum from '../../../../Enums/InputTypesEnum';
import CardHeader from './CardHeader';
import NoteCard from './NoteCard';
import DataTable from '../../../../Elements/DataTable/DataTableFigma';
import FieldTypesEnum from '../../../../Enums/FieldTypesEnum';
import moneyHelper from '../../../../Helpers/moneyHelper';

class OtherMiscCostsCard extends BaseCard {
  render() {
    const { Tier } = this.props;

    return (
      <div className='card'>
        {
          <CardHeader
            bodyactive={this.state.bodyactive}
            changeBodyStatus={this.changeBodyStatus}
            headerClassName='font--withAlert'
            sectionNumber={'5'}
            HeaderText={
              <>
                Other Misc costs (if applicable){' '}
                <span className='header-alert'>
                  &gt;&gt;&gt; Consider AI Scheduling cost 0.45 USD per report where possible. (Please adjust to local
                  currency)
                </span>
              </>
            }
            subtotal={moneyHelper.toMoneyFormat(this.props.Tier.RecruitingCostTotal, this.props.Tier.PricingDetails.CurrencyCode)}
            subtotalRev={this.props.Tier.RecruitingCostPct + ' of revenue'}
          />
        }
        {this.state.bodyactive ? (
          <div>
            <NoteCard
              name='EvaluatorRecruitingCostNotes'
              noteActive={this.state.noteActive}
              renderInputField={this.renderInputField}
              value={this.props.Tier.PricingDetails}
            />
            <DataTable
              type={{
                FieldsToShowInDataTable: this.FieldsToShowInFirstDataTable,
                NameOfTheIdField: () => 'TierId',
                FieldsToShowInListTable: [],
                MoneyFields: this.MoneyFields,
                Currency: this.Currency,
              }}
              DataTableType='Header'
              renderInputFieldFunction={this.renderInputField}
              thereIsNoSuchRowMessageCheck={false}
              smallDataTable={true}
            />
            <DataTable
              type={{
                FieldsToShowInDataTable: this.FieldsToShowInDataTable,
                NameOfTheIdField: () => 'TierId',
                FieldsToShowInListTable: [],
                MoneyFields: this.MoneyFields,
                Currency: this.Currency,
              }}
              itemList={Tier.PricingDetails}
              renderInputFieldFunction={this.renderInputField}
              DataTableType='Body'
              smallDataTable={true}
            />
            <DataTable
              type={{
                FieldsToShowInDataTable: this.FieldsToShowInDataTableAnnualCallsToShopperCost,
                NameOfTheIdField: () => 'TierId',
                FieldsToShowInListTable: [],
                MoneyFields: this.MoneyFields,
                Currency: this.Currency,
              }}
              itemList={Tier.PricingDetails}
              renderInputFieldFunction={this.renderInputField}
              DataTableType='Body'
              smallDataTable={true}
            />
            <DataTable
              type={{
                FieldsToShowInDataTable: this.FieldsToShowInDataTableAnnualMiscCost3,
                NameOfTheIdField: () => 'TierId',
                FieldsToShowInListTable: [],
                MoneyFields: this.MoneyFields,
                Currency: this.Currency,
              }}
              itemList={Tier.PricingDetails}
              renderInputFieldFunction={this.renderInputField}
              DataTableType='Body'
              smallDataTable={true}
            />
            <DataTable
              type={{
                FieldsToShowInDataTable: this.FieldsToShowInSecondDataTable,
                NameOfTheIdField: () => 'TierId',
                FieldsToShowInListTable: [],
                MoneyFields: this.MoneyFields,
                Currency: this.Currency,
              }}
              headeritemList={Tier}
              DataTableType='Header'
              thereIsNoSuchRowMessageCheck={false}
              smallDataTable={true}
            />
            <DataTable
              type={{
                FieldsToShowInDataTable: this.FieldsToShowInDataTableMiscCostPerCycleText1,
                NameOfTheIdField: () => 'TierId',
                FieldsToShowInListTable: [],
                MoneyFields: this.MoneyFields,
                Currency: this.Currency,
              }}
              itemList={Tier.PricingDetails}
              renderInputFieldFunction={this.renderInputField}
              DataTableType='Body'
              smallDataTable={true}
            />
            <DataTable
              type={{
                FieldsToShowInDataTable: this.FieldsToShowInDataTableMiscCostPerCycleText2,
                NameOfTheIdField: () => 'TierId',
                FieldsToShowInListTable: [],
                MoneyFields: this.MoneyFields,
                Currency: this.Currency,
              }}
              itemList={Tier.PricingDetails}
              renderInputFieldFunction={this.renderInputField}
              DataTableType='Body'
              smallDataTable={true}
            />
            <DataTable
              type={{
                FieldsToShowInDataTable: this.FieldsToShowInDataTableMiscCostPerCycleText3,
                NameOfTheIdField: () => 'TierId',
                FieldsToShowInListTable: [],
                MoneyFields: this.MoneyFields,
                Currency: this.Currency,
              }}
              itemList={Tier.PricingDetails}
              renderInputFieldFunction={this.renderInputField}
              smallDataTable={true}
              DataTableType='Body'
            />
          </div>
        ) : null}
        <footer>
          <DataTable
            type={{
              FieldsToShowInDataTable: this.FieldsToShowInFooterDataTable,
              MoneyFields: this.MoneyFields,
              Currency: this.Currency,
            }}
            headeritemList={this.props.Tier}
            thereIsNoSuchRowMessageCheck={false}
            smallDataTable={true}
          />
        </footer>
      </div>
    );
  }

  FieldsToShowInFirstDataTable() {
    // prettier-ignore
    return [
      { label: ' ', type:FieldTypesEnum.EmptySpace, tableminWidth: '250px' },
      { label: ' ', type:FieldTypesEnum.EmptySpace, tableminWidth: '500px' },
      { label: 'Annually', tableminWidth: '125px' },
      { label: '% of revenues', tableminWidth: '125px', headerPosition: 'header-text-right' },
    ];
  }

  FieldsToShowInDataTable() {
    // prettier-ignore
    return [
      { label: " ", data: "MiscCostText1", type: InputTypesEnum.Text2, tableminWidth: "250px" },
      { label: "Per Cycle", type: InputTypesEnum.TextReadOnly, tableminWidth: "500px" },
      { label: "Annually", data: "AnnualRecruitingCost", type: InputTypesEnum.Text2, tableminWidth: "125px", fieldType: "Decimal", },
      { label: "% of revenues", data: "PctMiscCost1", type: InputTypesEnum.TextReadOnly, tableminWidth: "125px", headerPosition: "header-text-right", },
    ];
  }

  FieldsToShowInDataTableAnnualCallsToShopperCost() {
    // prettier-ignore
    return [
      { label: "Misc Cost Per Cycle", data: "MiscCostText2", type: InputTypesEnum.Text2, tableminWidth: "250px" },
      { label: "Per Cycle", type: InputTypesEnum.TextReadOnly, tableminWidth: "500px" },
      { label: "Annually", data: "AnnualCallsToShopperCost", type: InputTypesEnum.Text2, tableminWidth: "125px", fieldType: "Decimal", },
      { label: "% of revenues", data: "PctMiscCost2", type: InputTypesEnum.TextReadOnly, tableminWidth: "125px", headerPosition: "header-text-right", },
    ];
  }

  FieldsToShowInDataTableAnnualMiscCost3() {
    // prettier-ignore
    return [
      { label: "Misc Cost Per Cycle", data: "MiscCostText3", type: InputTypesEnum.Text2, tableminWidth: "250px" },
      { label: "Per Cycle", type: InputTypesEnum.TextReadOnly, tableminWidth: "500px" },
      { label: "Annually", data: "AnnualMiscCost3", type: InputTypesEnum.Text2, tableminWidth: "125px", fieldType: "Decimal", },
      { label: "% of revenues", data: "PctMiscCost3", type: InputTypesEnum.TextReadOnly, tableminWidth: "125px", headerPosition: "header-text-right", },
    ];
  }

  FieldsToShowInSecondDataTable() {
    // prettier-ignore
    return [
      { label: " ", tableminWidth: "250px" },
      { label: " ", tableminWidth: "375px" },
      { label: "Per Cycle", tableminWidth: "125px" },
      { label: "Annually", tableminWidth: "125px", headerPosition: "header-text-right" },
      { label: "% of revenues", tableminWidth: "125px", headerPosition: "header-text-right" },
    ];
  }

  FieldsToShowInDataTableMiscCostPerCycleText1() {
    // prettier-ignore
    return [
      { label: "Misc Cost Per Cycle", data: "MiscCostPerCycleText1", type: InputTypesEnum.Text2, tableminWidth: "250px", },
      { label: " ", data: "", type: FieldTypesEnum.EmptySpace, tableminWidth: "375px" },
      { label: "Per Cycle", data: "MiscCostPerCycle1", type: InputTypesEnum.Text2, tableminWidth: "125px", fieldType: "Decimal", },
      { label: "Annually", data: "AnnualMiscCostPerCycle1", tableminWidth: "125px", headerPosition: "header-text-right", },
      { label: "% of revenues", data: "PctMiscCostPerCycle1", type: InputTypesEnum.TextReadOnly, tableminWidth: "125px", headerPosition: "header-text-right", },
    ];
  }
  FieldsToShowInDataTableMiscCostPerCycleText2() {
    // prettier-ignore
    return [
      { label: "Misc Cost Per Cycle", data: "MiscCostPerCycleText2", type: InputTypesEnum.Text2, tableminWidth: "250px", },
      { label: " ", data: "", type: FieldTypesEnum.EmptySpace, tableminWidth: "375px" },
      { label: "Per Cycle", data: "MiscCostPerCycle2", type: InputTypesEnum.Text2, tableminWidth: "125px", fieldType: "Decimal", },
      { label: "Annually", data: "AnnualMiscCostPerCycle2", tableminWidth: "125px", headerPosition: "header-text-right", },
      { label: "% of revenues", data: "PctMiscCostPerCycle2", type: InputTypesEnum.TextReadOnly, tableminWidth: "125px", headerPosition: "header-text-right", },
    ];
  }
  FieldsToShowInDataTableMiscCostPerCycleText3() {
    // prettier-ignore
    return [
      { label: "Misc Cost Per Cycle", data: "MiscCostPerCycleText3", type: InputTypesEnum.Text2, tableminWidth: "250px", },
      { label: " ", data: "", type: FieldTypesEnum.EmptySpace, tableminWidth: "375px" },
      { label: "Per Cycle", data: "MiscCostPerCycle3", type: InputTypesEnum.Text2, tableminWidth: "125px", fieldType: "Decimal", },
      { label: "Annually", data: "AnnualMiscCostPerCycle3", tableminWidth: "125px", headerPosition: "header-text-right", },
      { label: "% of revenues", data: "PctMiscCostPerCycle3", type: InputTypesEnum.TextReadOnly, tableminWidth: "125px", headerPosition: "header-text-right", },
    ];
  }
  FieldsToShowInFooterDataTable() {
    // prettier-ignore
    return [
      { label: "OTHER MISC COSTS", tableminWidth: "750px", headerPosition: "header-text-right" },
      { label: "", data: "RecruitingCostTotal", tableminWidth: "125px", headerPosition: "header-text-right" },
      { label: "", data: "RecruitingCostPct", tableminWidth: "125px", headerPosition: "header-text-right" },
    ];
  }
}

export default OtherMiscCostsCard;
